import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4681e949"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "outer"
}
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = { class: "section p-5" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = {
  key: 0,
  class: "buttons"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "progress is-small is-info"
}

import { ref, watch } from 'vue';
  import { useStoreRuntime } from '@/stores/runtime';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RuntimePopover',
  setup(__props) {

  const storeRuntime = useStoreRuntime();
  const popover = ref<any>({});

  watch(storeRuntime.ui.popover, (state) => {
    popover.value = state;
    document.querySelector('html').style.overflow = popover.value.active ? 'hidden' : 'auto';
  });

return (_ctx: any,_cache: any) => {
  return (popover.value.active)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(popover.value.title), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(popover.value.subtitle), 1),
              (popover.value.buttons.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popover.value.buttons, (button, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: index,
                        onClick: button.callback,
                        class: _normalizeClass([button.class, "button"])
                      }, _toDisplayString(button.title), 11, _hoisted_8))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (popover.value.progressbar.active)
            ? (_openBlock(), _createElementBlock("progress", _hoisted_9))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})